/* eslint-disable import/prefer-default-export */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();
